import React from 'react';
import { usePagination, DOTS } from '../../hooks/usePagination';
import ReactPaginate from 'react-paginate';
import "./pagination.css";

function ReadableMetaDescription({ pageSize, page, total }) {
  const firstEntry = ((page) * pageSize) + 1;
  const lastEntry = total < pageSize ? total : pageSize * (page + 1);
  if (total === 0) {
    return (
      <p className="text-sm text-gray-700">
        There are no results that match this filter.
      </p>
    );
  }
  return (
    <div className="hidden sm:block">
      <p className="text-sm text-gray-700">
        Showing
        {' '}
        <span className="font-medium">{firstEntry.toLocaleString()}</span>
        {' '}
        to
        {' '}
        <span className="font-medium">{lastEntry < total ? lastEntry.toLocaleString() : total.toLocaleString()}</span>
        {' '}
        of
        {' '}
        <span className="font-medium">{total.toLocaleString()}</span>
        {' '}
        results.
      </p>
    </div>
  );
}

const Pagination = ({
  onPaginationChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (paginationRange.length < 2) {
    return <ReadableMetaDescription pageSize={pageSize} page={currentPage} total={totalCount} />;
  }
  return (
    <>
      <div role="navigation" aria-label="Pagination" className="" style={{ marginBottom: 10 }}>
        <ReactPaginate
          containerClassName={"pagination"}
          pageLinkClassName={"page-item"}
          activeLinkClassName={"active-link"}
          previousClassName={"page-item"}
          nextClassName={"page-item"}
          breakLinkClassName={"page-item"}
          breakLabel="..."
          nextLabel="Next →"
          onPageChange={(p) => onPaginationChange(p.selected) }
          pageRangeDisplayed={5}
          initialPage={currentPage}
          // forcePage={currentPage}
          pageCount={Math.ceil(totalCount/pageSize)}
          previousLabel="← Previous"
          renderOnZeroPageCount={null}
        />
      </div>
      <div>
        <ReadableMetaDescription pageSize={pageSize} page={currentPage} total={totalCount} />
      </div></>
    
  );
};

export default Pagination;

